// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"3b89f65b","209":"cfe3cc39","329":"613e7fd8","409":"5c2baea8","434":"c6836844","489":"945856f1","530":"b803d6b6","536":"dd167141"}[chunkId] + ".chunk.js";
};